<template>
  <v-data-table
    dense
    :headers="headers"
    :items="data"
    :calculate-widths="true"
  >
    <template v-slot:item.vmsFeePercent="{ item }">
      {{ (item.vmsFeePercent || 0) | percent }}
    </template>
    <template v-slot:item.consultantOverheadPercent="{ item }">
      {{ item.consultantOverheadPercent | percent }}
    </template>
    <template v-slot:item.hourlyTotalPayRate="{ item }">
      {{ item.hourlyTotalPayRate | currency }}
    </template>
    <template v-slot:item.hourlyNetBillRate="{ item }">
      {{ item.hourlyNetBillRate | currency }}
    </template>
    <template v-slot:item.hourlyExpensesDeduction="{ item }">
      {{ item.hourlyExpensesDeduction | currency }}
    </template>
    <template v-slot:item.hourlyTotalGrossProfit="{ item }">
      <v-chip
        v-if="getColor(item.startDate, item.endDate)"
        :color="getColor(item.startDate, item.endDate)"
        dark
      >
        {{ item.hourlyTotalGrossProfit | currency }}
      </v-chip>
      <span v-else>
        {{ item.hourlyTotalGrossProfit | currency }}
      </span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        class="mx-1 my-1 hide-on-print"
        color="primary"
        outlined
        @click.prevent="handleShowAssignmentDetails($event, item)"
      >
        <v-icon color="primary">badge</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>

import { assignmentEditRoute } from '@/lib/constants/routes'
import { getLastDayOfCurrentMonth, getFirstDayOfCurrentMonth } from '@/lib/dates'

export default {
  props: [
    'data',
    'grossProfitByEmployee'
  ],
  data () {
    return {
      tab: 0,
      headers: [
        { text: 'Client', value: 'clientName', width: '250px' },
        { text: 'VMS Fee', value: 'vmsFeePercent', width: '120px', align: 'center' },
        { text: 'Consultant', value: 'consultantName', width: '250px' },
        { text: 'Consultant Type', value: 'consultantType', width: '150px' },
        { text: 'Overhead', value: 'consultantOverheadPercent', width: '120px', align: 'center' },
        { text: 'Total Pay Rate (H)', value: 'hourlyTotalPayRate', width: '160px', align: 'center' },
        { text: 'Net Bill Rate (H)', value: 'hourlyNetBillRate', width: '160px', align: 'center' },
        { text: 'Expenses Deduction (H)', value: 'hourlyExpensesDeduction', width: '200px', align: 'center' },
        { text: 'Net GP (H)', value: 'hourlyTotalGrossProfit', width: '120px', align: 'center' },
        { text: 'Contract', value: 'actions', width: '110px', align: 'center', sortable: false }
      ]
    }
  },
  methods: {
    getLastDayOfCurrentMonth,
    getFirstDayOfCurrentMonth,
    handleShowAssignmentDetails (event, item) {
      const routeData = this.$router.resolve({
        name: assignmentEditRoute.name,
        params: { id: item.assignmentId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    },
    getColor (startDate, endDate) {
      let starDateDateTime = new Date(startDate)
      let endDateDateTime = new Date(endDate)
      if (starDateDateTime >= this.getFirstDayOfCurrentMonth() && starDateDateTime <= this.getLastDayOfCurrentMonth()) {
        return 'success'
      }
      if (endDateDateTime >= this.getFirstDayOfCurrentMonth() && endDateDateTime <= this.getLastDayOfCurrentMonth()) {
        return 'error'
      }
      return null
    }
  }
}
</script>
